import React from 'react'
import { ToggleContext } from '@typesApp/WidgetContextHolder'
import { AppHOC, AppProps } from './AppHOC'

const InsuranceToggleContainer = React.lazy(() => import('@components/InsuranceToggle'))

type ToggleAppProps = AppProps & {
  context?: ToggleContext
}

export const InsuranceToggleApp: React.FC<ToggleAppProps> = props => {
  const { session, actionModule, environment, widgetContext, context } = props
  /**
   * FIXME: remove context prop once commerce F/E makes changes to configuration
   */
  return (
    <AppHOC
      session={session}
      environment={environment}
      actionModule={actionModule}
      widgetContext={widgetContext ?? { toggle: context }}
    >
      <InsuranceToggleContainer />
    </AppHOC>
  )
}
